// Os estilos-base vêm antes das telas: o CSS de cada tela (importado por ela) pode sobrescrever.
import './styles.css';
import { LindezaProvider } from '@lindeza/core/hooks';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app/App';
import { countOpen, initPwa } from './app/pwa';
import { buildRuntime } from './app/runtime';
import { applyTheme, useUi } from './app/ui';

applyTheme(useUi.getState().theme);
initPwa();
countOpen();

const runtime = buildRuntime();
void runtime.init();

// Para testes de ponta a ponta e suporte (ex.: window.lindeza.sync.getStatus()).
(window as unknown as { lindeza: typeof runtime }).lindeza = runtime;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LindezaProvider runtime={runtime}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </LindezaProvider>
  </StrictMode>,
);
